import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import USERS from '../../common/data/userDummyData';
import { demoPages, extraMenu } from '../../menu';
import Dropdown, { DropdownItem, DropdownMenu, DropdownToggle } from '../../components/bootstrap/Dropdown';
import Button from '../../components/bootstrap/Button';
import useDarkMode from '../../hooks/useDarkMode';
import { useMst } from '../../models';
import AuthService from '../../services/AuthService';
import { removeItem } from '../../lib/localstorage';
import { observer } from 'mobx-react';
import OffCanvas, { OffCanvasBody, OffCanvasHeader, OffCanvasTitle } from '../../components/bootstrap/OffCanvas';
import config from '../../config';
import { ChatAvatar } from '../../page/chat/Chat';
import sapvenderservice from '../../services/codeService';
import Avatar from '../../components/Avatar';
import userProfile from '../../assets/img/user-large.png';

export const UserAvatar = ({ srcSet, src }) => {
	return (
		<div className='user-avatar'>
			<img srcSet={srcSet} src={src} alt='Avatar' width={128} height={128} />
		</div>
	);
};
UserAvatar.propTypes = {
	src: PropTypes.string.isRequired,
	srcSet: PropTypes.string,
};
UserAvatar.defaultProps = {
	srcSet: null,
};

const User = observer(() => {
	const navigate = useNavigate();
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();
	const { user } = useMst();
	const [isNotiOffCanvasOpen, setIsNotiOffCanvasOpen] = useState(false);

	const [vendorName, setVendorName] = useState('')

	return (
		<>
      <div
				className='user'
				onClick={() => {
					setIsNotiOffCanvasOpen(true);
				}}>
				{/* <Icon icon={'Notifications'} className='navigation-icon' size='2x' /> */}
				<i className='ri-notification-2-line ri-xl'></i>
			</div>
			<OffCanvas isOpen={isNotiOffCanvasOpen} setOpen={setIsNotiOffCanvasOpen}>
				<OffCanvasHeader setOpen={setIsNotiOffCanvasOpen}>
					<OffCanvasTitle id={'notiTitle'}>알림</OffCanvasTitle>
				</OffCanvasHeader>
				<OffCanvasBody>
					<div className='d-flex h-50 justify-content-center align-items-center'>알림 내역이 없습니다.</div>
					{/* <Alert color={'primary'} shadow={'sm'} icon={'AcUnit'} isOutline>
						<AlertLink className={'text-decoration-none'} to={'/'}>
							<AlertHeading>알림 제목</AlertHeading>
							알림 내용
						</AlertLink>
					</Alert>
					<Alert color={'info'} shadow={'sm'} icon={'AccountBalance'} isOutline>
						<AlertLink className={'text-decoration-none'} to={'/user/management'}>
							<AlertHeading>알림1 제목</AlertHeading>
							알림1 내용
						</AlertLink>
					</Alert> */}
				</OffCanvasBody>
			</OffCanvas>
			<Dropdown>
				<DropdownToggle hasIcon={false}>
					{/* <div className='user'> */}
						{/* <UserAvatar srcSet={USERS.JOHN.srcSet} src={USERS.JOHN.src} /> */}
						{/* <i className='ri-user-line ri-xl'></i> */}
						<div className='d-flex align-items-center p-1' style={{cursor: 'pointer'}}>
						<span className="h5 mb-0 text-dark" style={{marginRight: '30px'}}>{vendorName}</span>
						<Avatar
							// eslint-disable-next-line react/jsx-props-no-spreading	
							src={user?.me?.profile || userProfile}
							className='me-2'
							size={30}
						/>
						<div className='chat-info-user ms-1' style={{display: 'flex', flexDirection:'column'}}>
							<div className=''>
								<span className='text-dark mb-0'>{user.me.name}</span>
								<span className='wrap-duty mb-0'>{user.me.rank ? user.me.rank : ''}</span>          
							</div>
							<span className='wrap-dpt' style={{ fontSize: '11px' }}>{user.me.agency ? user.me.agency : <>&nbsp;</>}</span>         
						</div>
					</div>
					{/* </div> */}
				</DropdownToggle>
				<DropdownMenu
          isAlignmentEnd={ 'right' }
        >
					<DropdownItem>
						<Button
							// icon='AccountBox'
							onClick={() => navigate(`../${extraMenu.profile.path}`)}>
							<i className='ri-file-user-line ri-xl me-2'></i>
							프로필
						</Button>
					</DropdownItem>

					{/* <DropdownItem>
					<Button
						icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
						onClick={() => setDarkModeStatus(!darkModeStatus)}
						aria-label='Toggle fullscreen'>
						{darkModeStatus ? 'Dark Mode' : 'Light Mode'}
					</Button>
				</DropdownItem> */}
					<DropdownItem isDivider />
					<DropdownItem>
						<Button
							onClick={async () => {
								removeItem('access-token');
								removeItem('user-idx');
								removeItem('refresh-token');
								removeItem('rootState');
								const newURL = window.location.protocol + "//" + window.location.host;// + "/" + window.location.pathname;
								location.href =  '/'+demoPages.login.path
							}}>
							<i className='ri-logout-box-r-line ri-xl me-2'></i>
							로그아웃
						</Button>
					</DropdownItem>
				</DropdownMenu>
			</Dropdown>
			
		</>
	);
});

export default User;
